module.exports = __webpack_public_path__ + "img/encaustic_1920_1080_mit_wasserzeichen_3.bdef9cec.jpg";